/**
 * PageHeader — Standard-Header-Konvention für alle Staff- und
 * Cockpit-Pages. Titel + Subtitle links, Actions rechts.
 *
 * Beispiel:
 *   <PageHeader
 *     title="Kunden"
 *     subtitle={`${customers.length} Personal-Users in Keycloak`}
 *     actions={<Button onClick={onInvite}>Einladen</Button>}
 *   />
 */

import type { ReactNode } from 'react'
import './PageHeader.css'

export interface PageHeaderProps {
  title: string
  subtitle?: ReactNode
  /** Optional Icon (Emoji oder Komponente) links vom Titel */
  icon?: ReactNode
  /** Action-Buttons rechts */
  actions?: ReactNode
  /** Tabs-Bar unter dem Header (z.B. für Hub-Pages) */
  tabs?: ReactNode
  className?: string
}

export function PageHeader({
  title,
  subtitle,
  icon,
  actions,
  tabs,
  className = '',
}: PageHeaderProps) {
  return (
    <header className={`page-header ${className}`.trim()}>
      <div className="page-header-row">
        <div className="page-header-text">
          <h1 className="page-header-title">
            {icon && <span className="page-header-icon">{icon}</span>}
            {title}
          </h1>
          {subtitle && <p className="page-header-subtitle">{subtitle}</p>}
        </div>
        {actions && <div className="page-header-actions">{actions}</div>}
      </div>
      {tabs && <div className="page-header-tabs">{tabs}</div>}
    </header>
  )
}

export default PageHeader
